<template>
  <a-popover :position="position">
    <slot></slot>
    <template #content>
      <a-image
        v-if="imgUrl"
        :width="imgWidth"
        :height="imgHeight"
        :src="imgUrl"
        :preview="preview"
      />
      <img
        v-else
        :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }"
        src="@/assets/images/no-content-img.png"
      />
    </template>
  </a-popover>
</template>

<script lang="ts" setup>
  defineProps({
    imgUrl: {
      type: String,
      default: '',
    },
    imgWidth: {
      type: String,
      default: '200',
    },
    imgHeight: {
      type: String,
      default: '200',
    },
    position: {
      type: String,
      default: 'right',
    },
    // popover中的图能否点击放大预览
    preview: {
      type: Boolean,
      default: false,
    },
  });
</script>

<script lang="ts">
  export default {
    // 用于鼠标悬浮图片放大图片显示
    name: 'ImgPopover',
  };
</script>

<style lang="less" scoped></style>
